import { render, staticRenderFns } from "./FarmaciaRecetaDirecta.vue?vue&type=template&id=6fc5d4a9&"
import script from "./FarmaciaRecetaDirecta.vue?vue&type=script&lang=js&"
export * from "./FarmaciaRecetaDirecta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports